export const loginPageTranslations = {
    en: {
        welcome_title: "Welcome Back",
        welcome_description: "Log in to access the admin dashboard, manage fighters, managers, and organizations, and continue your work.",
        sign_in_title: "Sign In",
        sign_in_subtitle: "Enter your credentials to continue",
        email_label: "Email",
        email_placeholder: "Enter your email",
        email_required: "Email is required",
        email_invalid: "Invalid email format",
        password_label: "Password",
        password_placeholder: "Enter your password",
        password_required: "Password is required",
        password_min_length: "Password must be at least 8 characters",
        sign_in_button: "Sign In",
        or_continue_with: "Or continue with",
        google_button: "Google",
        facebook_button: "Facebook",
        linkedin_button: "LinkedIn",
        no_account: "Don't have an account?",
        register_link: "Register",
        error_title: "Error",
        login_success: 'Login Success',
        error_auth_failed: "Authentication failed. Please try again.",
        error_login_failed: "Login failed. Please try again.",
        error_oauth_failed: "Failed to log in with {{provider}}. Please try again.",
        error_linkedin_failed: "Failed to log in with LinkedIn. Please try again.",
        error_close_button: "Close",
        language_select_label: "Select Language",
        language_en: "English",
        language_de: "German",
        language_hr: "Croatian"
    },
    de: {
        welcome_title: "Willkommen zurück",
        welcome_description: "Melden Sie sich an, um auf das Admin-Dashboard zuzugreifen, Kämpfer, Manager und Organisationen zu verwalten und Ihre Arbeit fortzusetzen.",
        sign_in_title: "Anmelden",
        sign_in_subtitle: "Geben Sie Ihre Zugangsdaten ein, um fortzufahren",
        email_label: "E-Mail",
        email_placeholder: "Geben Sie Ihre E-Mail ein",
        email_required: "E-Mail ist erforderlich",
        email_invalid: "Ungültiges E-Mail-Format",
        password_label: "Passwort",
        password_placeholder: "Geben Sie Ihr Passwort ein",
        password_required: "Passwort ist erforderlich",
        password_min_length: "Das Passwort muss mindestens 8 Zeichen lang sein",
        sign_in_button: "Anmelden",
        or_continue_with: "Oder fahren Sie fort mit",
        google_button: "Google",
        facebook_button: "Facebook",
        linkedin_button: "LinkedIn",
        no_account: "Sie haben kein Konto?",
        register_link: "Registrieren",
        error_title: "Fehler",
        login_success: 'Anmeldung erfolgreich',
        error_auth_failed: "Authentifizierung fehlgeschlagen. Bitte versuchen Sie es erneut.",
        error_login_failed: "Anmeldung fehlgeschlagen. Bitte versuchen Sie es erneut.",
        error_oauth_failed: "Anmeldung mit {{provider}} fehlgeschlagen. Bitte versuchen Sie es erneut.",
        error_linkedin_failed: "Anmeldung mit LinkedIn fehlgeschlagen. Bitte versuchen Sie es erneut.",
        error_close_button: "Schließen",
        language_select_label: "Sprache auswählen",
        language_en: "Englisch",
        language_de: "Deutsch",
        language_hr: "Kroatisch"
    },
    hr: {
    welcome_title: "Dobrodošli natrag",
    welcome_description: "Prijavite se da pristupite administratorskoj ploči, upravljate borcima, menadžerima i organizacijama te nastavite svoj rad.",
    sign_in_title: "Prijava",
    sign_in_subtitle: "Unesite svoje podatke za nastavak",
    email_label: "E-pošta",
    email_placeholder: "Unesite svoju e-poštu",
    email_required: "E-pošta je obavezna",
    email_invalid: "Neispravan format e-pošte",
    password_label: "Lozinka",
    password_placeholder: "Unesite svoju lozinku",
    password_required: "Lozinka je obavezna",
    password_min_length: "Lozinka mora imati najmanje 8 znakova",
    sign_in_button: "Prijavi se",
    or_continue_with: "Ili nastavi s",
    google_button: "Google",
    facebook_button: "Facebook",
    linkedin_button: "LinkedIn",
    no_account: "Nemate račun?",
    register_link: "Registrirajte se",
    error_title: "Pogreška",
    login_success: 'Prijava uspješna',
    error_auth_failed: "Autentifikacija nije uspjela. Molimo pokušajte ponovo.",
    error_login_failed: "Prijava nije uspjela. Molimo pokušajte ponovo.",
    error_oauth_failed: "Prijava s {{provider}} nije uspjela. Molimo pokušajte ponovo.",
    error_linkedin_failed: "Prijava s LinkedIn nije uspjela. Molimo pokušajte ponovo.",
    error_close_button: "Zatvori",
    language_select_label: "Odaberite jezik",
    language_en: "Engleski",
    language_de: "Njemački",
    language_hr: "Hrvatski"
}
  };